import { CompanyItem } from '../../../../../domain/company-item';
import { RubricaService } from '../../../../../services/rubrica.service';
import { AlertService } from '../../../../../services/ui/alert.service';
import { FormService } from '../../../../../services/ui/form.service';

export const RubricaSearchPRModalComponent = {
    template: require('./rubrica-search-pr-modal.html'),
    controller: class RubricaSearchPRModalComponent {

        static $inject: string[] = [
            'RubricaService',
            'AlertService',
            'FormService'
        ];

        private items: Array<CompanyItem>;

        private filter: any;
        private isSearching: boolean;

        private close: any;

        constructor(
            private rubricaService: RubricaService,
            private alertService: AlertService,
            private formService: FormService
        ) {
            this.formService.resetFormSubmitted();

            this.items = [];

            this.filter = {
                'company_name': '',
                'email_pec': '',
                'codice_destinatario': '',
                'pageNumber': 1,
                'pageSize': 1000
            };
            this.isSearching = false;
        }

        search = () => {
            this.isSearching = true;

            this.rubricaService.getDocuments(this.filter)
                .then((response: any) => {
                    this.items = response.resultList;
                    this.isSearching = false;

                    if (this.items.length === 0) {
                        this.alertService.alert('warning', 'Nessun Destinatario trovato.');
                    }
                }, (error) => {
                    this.alertService.alert('error', error);
                    this.isSearching = false;
                });
        }

        $onInit(): void {
            this.search();
        }

        select(item: CompanyItem) {
            let isError = this.validateDestinatarioRequiredFields(item);
            if (isError) {
                return;
            }

            this.close({ $value: item });
        }

        private validateDestinatarioRequiredFields (item: CompanyItem) {
            let requiredFields = {
                'indirizzo': 'Indirizzo',
                'cap': 'CAP',
                'comune': 'Comune'
            };

            let isError = false;
            let errorDetails = [];

            for (let field in requiredFields) {
                if (item[field] === '' || item[field] === undefined) {
                    if (!isError) {
                        isError = true;
                    }
                    errorDetails.push(requiredFields[field]);
                }
            }

            if (item.fiscal_code === '' || item.fiscal_code === undefined) {
                if (item.piva === '' || item.piva === undefined) {
                    if (!isError) {
                        isError = true;
                    }
                    errorDetails.push('Partita Iva o Codice Fiscale');
                }
            }

            if (item.email_pec === '' || item.email_pec === undefined) {
                if (item.codice_destinatario === '' || item.codice_destinatario === undefined) {
                    if (!isError) {
                        isError = true;
                    }
                    errorDetails.push('Codice Destinatario o PEC');
                }
            }

            if (isError) {
                let errorDetailsHtml = `
                    <div class=\'margin-bottom - 10\'>
                    Attenzione! Non hai inserito tutti i dati obbligatori del Destinatario. Se hai selezionato il destinatario dalla Rubrica, <a ng-click=\'$ctrl.$state.go("usersettings.anagrafica"); $ctrl.$parent.close(); $ctrl.close();\'>
                    <span class=\'bold underlined\'>entra in Rubrica e modifica il contatto con i dati necessari</span></a></div>
                ` + this.getErrorDetailsHtml(errorDetails);
                this.close();
                this.alertService.alert('error', errorDetailsHtml);
            }

            return isError;
        }

        private getErrorDetailsHtml(errorDetails: Array<string>) {
            let html = '<div class=\'margin-bottom - 5\'>Dati mancanti o errati: ';
            for (let detail of errorDetails) {
                html += '<div class=\'red\'>' + detail + '</div>';
            }
            html += '</div>';

            return html;
        }
    },
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/rubrica-search-pr-modal/rubrica-search-pr-modal.ts